import { api } from '../configs/axiosConfigs';

export const getEmailTemplate = async () => api.get('/email_template');
// An empty body puts the default wording back.
export const saveEmailTemplate = async (body: string) => api.put('/email_template', { body });

// Which email app drafts open in (see EmailClients on the server).
export const saveEmailClient = async (emailClient: string) => api.put('/email_template', { email_client: emailClient });
